!function (e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t(require("react")) : "function" == typeof define && define.amd ? define("ati-ui-react", ["react"], t) : "object" == typeof exports ? exports["ati-ui-react"] = t(require("react")) : e["ati-ui-react"] = t(e.React);
}(this, function (n) {
  return i = {}, o.m = r = {
    0: function (e, t) {
      e.exports = n;
    },
    19: function (e, t, n) {
      "use strict";

      e.exports = function (e) {
        for (var t = "", n = e = void 0 === e ? 21 : e; n--;) t += "ModuleSymbhasOwnPr-0123456789ABCDEFGHNRVfgctiUvz_KqYTJkLxpZXIjQW"[64 * Math.random() | 0];
        return t;
      };
    },
    2: function (e, t, o) {
      "use strict";

      var n,
        r,
        u = function () {
          return n = void 0 === n ? !(!(window && document && document.all) || window.atob) : n;
        },
        i = (r = {}, function (e) {
          if (void 0 === r[e]) {
            var t = document.querySelector(e);
            if (window.HTMLIFrameElement && t instanceof window.HTMLIFrameElement) try {
              t = t.contentDocument.head;
            } catch (e) {
              t = null;
            }
            r[e] = t;
          }
          return r[e];
        }),
        f = [];
      function s(e) {
        for (var t = -1, n = 0; n < f.length; n++) if (f[n].identifier === e) {
          t = n;
          break;
        }
        return t;
      }
      function a(e, t) {
        for (var n = {}, r = [], o = 0; o < e.length; o++) {
          var i = e[o],
            c = t.base ? i[0] + t.base : i[0],
            u = n[c] || 0,
            a = "".concat(c, " ").concat(u);
          n[c] = u + 1;
          u = s(a), i = {
            css: i[1],
            media: i[2],
            sourceMap: i[3]
          };
          -1 !== u ? (f[u].references++, f[u].updater(i)) : f.push({
            identifier: a,
            updater: function (t, e) {
              var n, r, o;
              {
                var i;
                o = e.singleton ? (i = y++, n = h = h || l(e), r = d.bind(null, n, i, !1), d.bind(null, n, i, !0)) : (n = l(e), r = function (e, t, n) {
                  var r = n.css,
                    o = n.media,
                    n = n.sourceMap;
                  o ? e.setAttribute("media", o) : e.removeAttribute("media");
                  n && "undefined" != typeof btoa && (r += "\n/*# sourceMappingURL=data:application/json;base64,".concat(btoa(unescape(encodeURIComponent(JSON.stringify(n)))), " */"));
                  if (e.styleSheet) e.styleSheet.cssText = r;else {
                    for (; e.firstChild;) e.removeChild(e.firstChild);
                    e.appendChild(document.createTextNode(r));
                  }
                }.bind(null, n, e), function () {
                  !function (e) {
                    if (null === e.parentNode) return;
                    e.parentNode.removeChild(e);
                  }(n);
                });
              }
              return r(t), function (e) {
                e ? e.css === t.css && e.media === t.media && e.sourceMap === t.sourceMap || r(t = e) : o();
              };
            }(i, t),
            references: 1
          }), r.push(a);
        }
        return r;
      }
      function l(e) {
        var t,
          n = document.createElement("style"),
          r = e.attributes || {};
        if (void 0 !== r.nonce || (t = o.nc) && (r.nonce = t), Object.keys(r).forEach(function (e) {
          n.setAttribute(e, r[e]);
        }), "function" == typeof e.insert) e.insert(n);else {
          e = i(e.insert || "head");
          if (!e) throw Error("Couldn't find a style target. This probably means that the value for the 'insert' parameter is invalid.");
          e.appendChild(n);
        }
        return n;
      }
      var c,
        p = (c = [], function (e, t) {
          return c[e] = t, c.filter(Boolean).join("\n");
        });
      function d(e, t, n, r) {
        n = n ? "" : r.media ? "@media ".concat(r.media, " {").concat(r.css, "}") : r.css;
        e.styleSheet ? e.styleSheet.cssText = p(t, n) : (r = document.createTextNode(n), (n = e.childNodes)[t] && e.removeChild(n[t]), n.length ? e.insertBefore(r, n[t]) : e.appendChild(r));
      }
      var h = null,
        y = 0;
      e.exports = function (e, i) {
        (i = i || {}).singleton || "boolean" == typeof i.singleton || (i.singleton = u());
        var c = a(e = e || [], i);
        return function (e) {
          if ("[object Array]" === Object.prototype.toString.call(e = e || [])) {
            for (var t = 0; t < c.length; t++) {
              var n = s(c[t]);
              f[n].references--;
            }
            for (var e = a(e, i), r = 0; r < c.length; r++) {
              var o = s(c[r]);
              0 === f[o].references && (f[o].updater(), f.splice(o, 1));
            }
            c = e;
          }
        };
      };
    },
    230: function (e, t, n) {
      (t = e.exports = n(4)()).push([e.i, "._3Wz8a-2-0-721{text-decoration:none;outline:0;cursor:pointer}", ""]), t.locals = {
        "no-link-decor": "_3Wz8a-2-0-721"
      };
    },
    4: function (e, t) {
      e.exports = function () {
        var c = [];
        return c.toString = function () {
          for (var e = [], t = 0; t < this.length; t++) {
            var n = this[t];
            n[2] ? e.push("@media " + n[2] + "{" + n[1] + "}") : e.push(n[1]);
          }
          return e.join("");
        }, c.i = function (e, t) {
          "string" == typeof e && (e = [[null, e, ""]]);
          for (var n = {}, r = 0; r < this.length; r++) {
            var o = this[r][0];
            "number" == typeof o && (n[o] = !0);
          }
          for (r = 0; r < e.length; r++) {
            var i = e[r];
            "number" == typeof i[0] && n[i[0]] || (t && !i[2] ? i[2] = t : t && (i[2] = "(" + i[2] + ") and (" + t + ")"), c.push(i));
          }
        }, c;
      };
    },
    600: function (e, t, n) {
      "use strict";

      n.r(t), n.d(t, "default", function () {
        return p;
      });
      var r = n(0),
        c = n.n(r),
        o = n(19),
        u = n.n(o),
        t = n(2),
        o = n.n(t),
        t = n(230),
        n = n.n(t),
        t = {
          insert: "head",
          singleton: !1
        },
        a = (o()(n.a, t), n.a.locals || {});
      function i(e) {
        return (i = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
          return typeof e;
        } : function (e) {
          return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
        })(e);
      }
      function f(e, t) {
        return (f = Object.setPrototypeOf || function (e, t) {
          return e.__proto__ = t, e;
        })(e, t);
      }
      function s(n) {
        var r = function () {
          if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" == typeof Proxy) return !0;
          try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
          } catch (e) {
            return !1;
          }
        }();
        return function () {
          var e,
            t = l(n);
          return e = r ? (e = l(this).constructor, Reflect.construct(t, arguments, e)) : t.apply(this, arguments), t = this, !(e = e) || "object" !== i(e) && "function" != typeof e ? function (e) {
            if (void 0 !== e) return e;
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          }(t) : e;
        };
      }
      function l(e) {
        return (l = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
          return e.__proto__ || Object.getPrototypeOf(e);
        })(e);
      }
      n = function () {
        !function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
          e.prototype = Object.create(t && t.prototype, {
            constructor: {
              value: e,
              writable: !0,
              configurable: !0
            }
          }), t && f(e, t);
        }(i, r["PureComponent"]);
        var o = s(i);
        function i() {
          var t;
          !function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, i);
          for (var e = arguments.length, n = Array(e), r = 0; r < e; r++) n[r] = arguments[r];
          return (t = o.call.apply(o, [this].concat(n))).openPopup = function (e) {
            e.preventDefault();
            e = u()();
            t.props.disabled || (window.open(t.props.href, e, t.props.params), t.props.onPopupOpen && t.props.onPopupOpen(e, t.props.href));
          }, t.render = function () {
            return c.a.createElement("a", {
              className: [a["no-link-decor"], t.props.className].join(" "),
              href: "".concat(t.props.href),
              onClick: t.openPopup,
              "data-name": t.props.name
            }, t.props.children);
          }, t;
        }
        return i;
      }();
      n.defaultProps = {
        className: "",
        params: "top=150,left=200,width=1000,height=800,resizable=1,scrollbars=1,menubar=0"
      };
      var p = n;
    }
  }, o.c = i, o.d = function (e, t, n) {
    o.o(e, t) || Object.defineProperty(e, t, {
      enumerable: !0,
      get: n
    });
  }, o.r = function (e) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(e, "__esModule", {
      value: !0
    });
  }, o.t = function (t, e) {
    if (1 & e && (t = o(t)), 8 & e) return t;
    if (4 & e && "object" == typeof t && t && t.__esModule) return t;
    var n = Object.create(null);
    if (o.r(n), Object.defineProperty(n, "default", {
      enumerable: !0,
      value: t
    }), 2 & e && "string" != typeof t) for (var r in t) o.d(n, r, function (e) {
      return t[e];
    }.bind(null, r));
    return n;
  }, o.n = function (e) {
    var t = e && e.__esModule ? function () {
      return e.default;
    } : function () {
      return e;
    };
    return o.d(t, "a", t), t;
  }, o.o = function (e, t) {
    return Object.prototype.hasOwnProperty.call(e, t);
  }, o.p = "", o(o.s = 600);
  function o(e) {
    if (i[e]) return i[e].exports;
    var t = i[e] = {
      i: e,
      l: !1,
      exports: {}
    };
    return r[e].call(t.exports, t, t.exports, o), t.l = !0, t.exports;
  }
  var r, i;
});